import React from 'react';

import AppsCluster from '../SubscribeTest/OfferSelection/Clusters/AppsCluster';

const AppSection = () => (
  <section className="md:max-w relative mx-auto w-full border-0 border-b border-solid border-grayscale-charcoal pt-64 sm:max-w-[1040px] md:pt-112 xl:max-w-[1130px]">
    <AppsCluster className="pb-0 lg:pb-80" />
  </section>
);

export default AppSection;
